var messages = {
  en: {
    dueDateWarning: 'Monthly closure, no modification!'
  },
  zh_CN: {
    common: {
      dueDateWarning: '当前状态，不能进行修改!',
      defaultValue: '默认 '
    }
  }
};

export default messages
